export const mobileBreakpoint = 786;
export const isMobileView = () => window.outerWidth <= mobileBreakpoint;
